import React from 'react';
import {StyleSheet} from 'react-native';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {DocumentsForm} from './forms/DocumentsForm';
import {useSalesmanContext} from '../../../../../../context/salesman';
import {ISalesmanClient} from '../../../../../../interfaces/dtos';
import {IDocumentClient} from '../../../../../../interfaces/dtos/salesman-client.interface';
import InternalTemplate from '../../../../../../components/templates/internal';
import {SpinnerModal} from '../../../../../../components/modals';
import {message} from '../../../../../../utils/messages';
import {StackParamList} from '../../../../../../navigators';
import useToast from '../../../../../../hooks';
import { readFile } from './utils/read-file';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'AddClientStep3Screen'
>;

export const AddClientStep3Screen = ({navigation}: ScreenProps) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const {
    salesmanNewClientRequest,
    setSalesmanNewClientRequest,
    customerRequiredDocumentList: requiredDocumentList,
    sendSalesmanNewClientRequest,
  } = useSalesmanContext();

  const {showCustomerRegistrationError} = useToast();

  const handleGoBack = () => {
    setIsLoading(false);
    navigation.pop(1);
  };

  const handleOnSubmit = async (list: IDocumentClient[]) => {
    const salesmanNewClient = {
      ...salesmanNewClientRequest,
      documents: list,
    } as ISalesmanClient;

    setSalesmanNewClientRequest(salesmanNewClient);

    setIsLoading(true);

    try {
      for (const item of list) {
        if (item.document.content === undefined) {
          item.document.content = await readFile(
            item.document.uri
          );
        }
      }
    } catch (ex) {
      setIsLoading(false);
      showCustomerRegistrationError();
      return false;
    }

    const {status, request} = await sendSalesmanNewClientRequest(list);

    if (status === 'fail') {
      setIsLoading(false);
      showCustomerRegistrationError();
      return false;
    }

    setIsLoading(false);
    if (status === 'ok') {
      navigation.navigate('SalesmanNewClientRequestSuccess');
    } else {
      navigation.navigate('WithoutConnectionConfirm', {
        request,
        workflow: 'customer-registration',
      });
    }
    return true;
  };

  const handlerOnHelpTap = () => {
    navigation.navigate('SalesmanCustomerHelpDocuments');
  };

  return (
    <InternalTemplate
      title={'salesman-add-client-documents-title'}
      childContainerStyle={styles.childContainerStyle}
      backButton={{
        label: 'go-back',
        onPress: () => handleGoBack(),
        usage: 'external',
      }}
      contentPaddingX="0">
      <SpinnerModal
        show={isLoading}
        title={message('send-request-new-customer-loading-title')}
      />
      <DocumentsForm
        onSubmit={handleOnSubmit}
        {...{customerRequiredDocumentList: requiredDocumentList}}
        onHelpTap={handlerOnHelpTap}
      />
    </InternalTemplate>
  );
};

const styles = StyleSheet.create({
  childContainerStyle: {
    paddingBottom: '100%',
  },
});
